//import Snap from 'snapsvg'
import '@fortawesome/fontawesome-free/scss/brands.scss'
import '@fortawesome/fontawesome-free/scss/regular.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/js/all.js'
import 'jquery.easing'
import payform from 'payform'
import { stringify } from 'querystring'

export const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

const svgLoaded = fileName => {
    return new Promise(function (onSuccess, onFailed) {
        const paper = Snap().remove()
        Snap.load(fileName, function (svg) {
            paper.attr(
                'viewBox',
                svg.node.viewBox.baseVal.x +
                ' ' +
                svg.node.viewBox.baseVal.y +
                ' ' +
                svg.node.viewBox.baseVal.width +
                ' ' +
                svg.node.viewBox.baseVal.height
            )
            paper.attr('xmlns', 'http://www.w3.org/2000/svg')
            paper.append(svg.selectAll('svg>*'))
            onSuccess(paper)
        })
    })
}

const svgReplace = (selectorList) => {
    // 画像をインラインsvgに書換
    let objList = document.querySelectorAll(selectorList || "img.svg-inline")
    return Promise.all([...objList].map(elm => {
        return new Promise((resolve, reject) => {
            let path = $(elm).attr('src');
            Promise.resolve()
                .then(() => {
                    return svgLoaded(path);
                })
                .then(targetSvg => {
                    let parentDom = elm.parentNode;
                    parentDom.replaceChild(targetSvg.node, elm);
                    resolve(targetSvg);
                })
        })
    }))
}

export const innerScroll = () => {
    $('a[href*="#"]').each(function () {
        $(this).on('click', function () {
            let pageKey = $(this).attr('href').replace(/^.*?#/, '#');
            if (!pageKey) {
                return true;
            }

            let pos = pageKey == '#' ? 0 : $(pageKey).position().top;
            $('body, html').animate({ scrollTop: pos }, 500, 'easeOutQuint');
            return false;
        })
    })
}

export const imgPreload = imgPathList => {
    return Promise.all(imgPathList.map(_path => {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
                resolve();
            }
            img.onerror = () => {
                reject();
            }
            img.src = _path;
        })
    }))
}

export const loadTemplate = (id) => {
    const content = document.querySelector(`#${id}`).content
    console.log(content)
    return document.importNode(content, true)
}

export const setCreditCardFormat = (inputName, baseObj = document) => {
    /*
    let timerId = false
    let onAction = ['keyup','blur','change']
    onAction.forEach(_onAction => {
        baseObj.querySelector(`input[name="${inputName}"]`).addEventListener(_onAction, e => {
            if (timerId != false)  clearTimeout(timerId);
            timerId = setTimeout(() =>{
                let val = e.target.value
                if(val.match(/(\d{4}\s){3}(\d{2,4})$/)){
                    return false
                }
                val = val.replace(/(\d{4}(?!\s))/g, "$1 ")
                e.target.value = val
            },400)
        })
    })
    */
    let input = baseObj.querySelector(`input[name="${inputName}"]`)
    payform.cardNumberInput(input)
}

export const alertAction = () => {
    $('body .alert').delay(3000).fadeOut(200).queue(function () {
        this.remove()
    })

    $('body .alert').on('click', e => {
        $(e.currentTarget).stop().fadeOut()
    })
}

export const submitFetch = async (path, type = "GET", data = null, params = {}) => {
    let send = Object.assign({}, params, {
        method: type,
        credentials: 'same-origin',
    })
    switch (type) {
        case 'GET':
            if (data) {
                let bodyStringify = stringify(data)
                path = `${path}?${bodyStringify}`
            }
            break
        default:
            let formData = new FormData()
            for (let key in data) {
                formData.append(key, data[key]);
            }
            Object.assign(send, { body: formData })
    }

    let resp = await fetch(path, send)
    return resp.json()
}

export const areaCheck = () => {
    const mainObj = $('#create-form')
    mainObj.find('.item.area input[type="checkbox"]').on('click', e => {
        let parent
        if (parent = $(e.currentTarget).attr('data-parent')) { // 子要素をチェックしたとき
            mainObj.find(`.item.area input[type="checkbox"][value="${parent}"]`)
                .prop('checked', false)

            if ($(e.currentTarget).prop('checked')) {
                let unchkCnt = mainObj.find(`.item.area input[type="checkbox"][data-parent="${parent}"]:not(:checked)`).length

                if (unchkCnt == 0) { // 子要素を全チェックで親要素もチェック
                    mainObj.find(`.item.area input[type="checkbox"][value="${parent}"]`)
                        .prop('checked', true)
                }
            }
        } else { // 親要素をチェックしたとき
            let value = $(e.currentTarget).val()
            if ($(e.currentTarget).prop('checked')) {
                mainObj.find(`.item.area input[type="checkbox"][data-parent="${value}"]`)
                    .prop('checked', true)
            } else {
                mainObj.find(`.item.area input[type="checkbox"][data-parent="${value}"]`)
                    .prop('checked', false)
            }
        }
    })
}
export const areaSearchCheck = () => {
    const mainObj = $('#search-cond')
    mainObj.find('.item.area input[type="checkbox"]').on('click', e => {
        if (!$(e.currentTarget).attr('data-parent')) { // 親要素
            let value = $(e.currentTarget).val()
            mainObj.find(`.item.area input[type="checkbox"][data-parent="${value}"]`)
                .prop('disabled', $(e.currentTarget).prop('checked'))
            if ($(e.currentTarget).prop('checked')) {
                mainObj.find(`.item.area input[type="checkbox"][data-parent="${value}"]`).prop('checked', false)
            }
        }
    })
}
export const footerNavAction = () => {
    let showFlg = true
    let positionCurrent = 0
    const targetDom = $('#fixed-nav:not(.hide)')

    $(window).scroll(() => {
        const positionDiff = positionCurrent - $(window).scrollTop()
        positionCurrent = $(window).scrollTop()

        if (positionDiff >= 0 && positionCurrent + $(window).height() < $(document).height()) {
            if (!showFlg) {
                targetDom.stop().fadeIn()
                showFlg = true
            }
        } else {
            if (showFlg) {
                targetDom.stop().fadeOut()
                showFlg = false
            }
        }
    })
}

const init = () => {
    alertAction()
}
init()
